import ReviewSummaryReportProvider from './ReviewSummaryReportProvider';

export default ReviewSummaryReportProvider;
